const About = () => {
  return (
    <div
      className="w-full min-h-[80vh]  md:min-h-[90vh] lg:min-h-[80vh] xl:min-h-[70vh] fhd:min-h-[80vh] bg-no-repeat bg-center bg-contain bg-scroll mb-0 px-4 xl:px-24 mt-10 lg:mt-[80px] xl:mt-[75px] fhd:mt-[100px] max-w-[1920px] mx-auto"
      style={{
        backgroundImage: "url('/assests/plusBG.png')",
      }}
    >
      <div className="flex justify-center mb-12">
        <p className="font-prata text-[30px] xl:text-[40px] 2xl:text-[48px] fhd:mb-10">
          Who We Serve?
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center lg:items-stretch gap-6 xl:gap-8 2xl:gap-12 mb-10">
        {[
          {
            title: "Patients",
            img: "/assests/boxPatient.png",
            description: (
              <>
                Book trusted healthcare services for
                <br /> nursing or physiotherapy needs. Get
                <br /> quality care in the comfort of your
                <br /> home.
              </>
            ),
          },
          {
            title: "Nurse",
            img: "/assests/boxNurse.png",
            description: (
              <>
                Expand your reach and find
                <br />
                appointments with patients in need
                <br />
                of home-based nursing services.
                <br />
                Take control of your schedule and
                <br />
                provide impactful care.
              </>
            ),
          },
          {
            title: "Physiotherapists",
            img: "/assests/boxPhysio.png",
            description: (
              <>
                Book trusted healthcare services for
                <br /> nursing or physiotherapy needs. Get
                <br /> quality care in the comfort of your
                <br /> home.
              </>
            ),
          },
        ].map(({ title, img, description }, index) => (
          <div
            key={index}
            className="flex flex-col border border-[#4085FAA1] rounded-lg p-4 md:p-5 xl:p-6 2xl:p-8 w-full max-w-[400px] 2xl:max-w-[450px] bg-[rgba(237,243,255,0.30)] "
          >
            <div className="flex justify-center items-center mb-4">
              <img
                src={img}
                alt={title.toLowerCase()}
                className="w-full h-auto lg:h-auto fhd:h-[300px]"
                style={{ maxHeight: "500px" }}
              />
            </div>
            <div className="flex-grow"></div>
            <p className="font-prata text-[#185ADB] text-[26px] fhd:text-[34px] 2xl:text-[34px] mb-3">
              {title}
            </p>
            <p className="font-rubik text-[#585858] text-[13px] fhd:text-[20px] 2xl:text-[16px]">
              {description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
